export const STORAGE_SETTINGS_KEY = "animation-editor:current-settings";
